import React, { useState, useEffect, useRef } from 'react';
import '../styles/KeyFocusTabs.css';
import { FaUsers, FaBook, FaBrain } from 'react-icons/fa';
import RamadanImage from '../images/ramadan.png'; // Import the decorative image

const KeyFocusTabs = () => {
  const focusAreas = [
    {
      icon: <FaUsers />,
      title: "Leadership Development",
      content: (
        <>
          <p>
            Leadership is a cornerstone of progress. At Qibla, we focus on guiding
            and inspiring leaders grounded in Islamic values to drive meaningful change.
            Our programs emphasize ethical leadership, vision building, and decision-making
            skills inspired by the Prophet Muhammad (peace be upon him).
          </p>
          <ul>
            <li>Workshops on ethical leadership</li>
            <li>Case studies on successful Islamic leaders</li>
            <li>Interactive sessions on decision-making rooted in faith</li>
          </ul>
        </>
      ),
    },
    {
      icon: <FaBook />,
      title: "Islamic Pedagogy",
      content: (
        <>
          <p>
            Islamic Pedagogy integrates the spiritual, intellectual, and emotional
            dimensions of education. Our platform offers courses and resources designed
            to empower educators with tools and methods rooted in Islamic principles
            while embracing modern teaching techniques.
          </p>
          <ul>
            <li>Comprehensive training in Tarbiya (holistic nurturing)</li>
            <li>Practical tools for integrating Islamic principles in education</li>
            <li>Workshops on faith-based classroom management</li>
          </ul>
        </>
      ),
    },
    {
      icon: <FaBrain />,
      title: "Personal-Development",
      content: (
        <>
          <p>
            Self-development is a lifelong journey of personal and spiritual growth.
            At Qibla, we emphasize the importance of aligning one’s actions and aspirations
            with Islamic teachings to unlock potential and fulfill responsibilities towards
            Allah (SWT) and humanity.
          </p>
          <ul>
            <li>Workshops on personal goal setting</li>
            <li>Guidance on maintaining mental well-being</li>
            <li>Sessions on spiritual growth and mindfulness</li>
          </ul>
        </>
      ),
    },
  ];

  const [activeTab, setActiveTab] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // Auto-switch tabs
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTab((prevTab) => (prevTab + 1) % focusAreas.length);
    }, 5000); // Switch tabs every 5 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  }, [focusAreas.length]);

  // Intersection Observer for detecting visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="key-focus-tabs" ref={sectionRef}>
      <div className="tabs-container">
        <h2 className="tabs-heading">Our Key Focus Areas</h2>
        <div className="tabs">
          {focusAreas.map((item, index) => (
            <button
              key={index}
              className={`tab-button ${activeTab === index ? "active" : ""}`}
              onClick={() => setActiveTab(index)}
            >
              {item.icon} <span className="tab-title">{item.title}</span>
            </button>
          ))}
        </div>
        <div className="tab-content">
          <h3 className="tab-title">{focusAreas[activeTab].title}</h3>
          <div className="tab-description">{focusAreas[activeTab].content}</div>
        </div>
      </div>
      {isVisible && <img src={RamadanImage} alt="Ramadan Decoration" className="ramadan-decoration" />}
    </section>
  );
};

export default KeyFocusTabs;
